<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-qrcode', fontSet: 'fad'}"
	[headerText]="T.SCAN_QR_CODE_DIALOG_TITLE | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<div dialogContent class="qrCodeVideoCon">
		<mat-form-field color="accent" class="full-width-form">
			<mat-label>Select Video Source</mat-label>
			<mat-select [formControl]="sourceOptionFC" required>
				@for (sourceOption of sourceOptions; track sourceOption.value) {
					<mat-option [value]="sourceOption.value">{{ sourceOption.label }}</mat-option>
				}
			</mat-select>
			@if (sourceOptionFC.hasError("required")) {
				<mat-error>Please choose a video source</mat-error>
			}
		</mat-form-field>

		<div class="videoCon">
			<sim-component-loading-container
				[showBackDrop]="true"
				[backdropVariantTwo]="true"
				[isLoading]="isLoadingVideoSource()"
				[loadingIcon]="'fad fa-video'"
				[loadingMessage]="'Loading Camera Source'"
			/>

			<video #videoElement id="video" width="100%" height="400"></video>
		</div>
	</div>

	<div actions>
		<div class="scanStatus">
			{{ statusText() }}
		</div>

		<div class="actionButtonHolder">
			<button class="resetQRCodeBtn" mat-button color="accent" (click)="resetQRCodeScanner()">
				{{ T.QR_CODE_SCANNER_RESET_QR_CODE_SCANNER | translate }}
			</button>
		</div>
	</div>
</sim-basic-material-dialog>
